import { useMemo } from 'react';
import CompanyProperties from '../CompanyProperties';
import { CompanyModalSkeleton } from '../CompanyModalSkeleton';
import ExperienceTags
  from '../../../../modules/application/components/match-card/timeline/experience-container/experience-item-tags/experience-item-tags.component';
import { ExperienceTagType }
  from '../../../../modules/application/components/match-card/timeline/experience-container/experience-item-tags/experience-item-tags.enums';
import { ExperienceTag } from '../../../../modules/application/components/match-card/timeline/experience-container/experience-item-tags/experience-item-tags';
import { CompanyInsightData } from '../../../../hooks/get-company-by-id.hook';
import { formatExactLocation } from '../../../../utils/location';
import {
  ModalHeader,
  CompanyLogoImage,
  CompanyNameAndLocationWrapper,
  CompanyBaseDetailsWrapper,
  CompanyNameLabel,
  CompanyLocationLabel,
  Divider,
  CompanyOtherDetailsWrapper,
  CompanyDescription,
  LogoFallback,
} from './styled';

type ModalContentsProps = {
  companyInsightData: CompanyInsightData,
  isLoading: boolean,
}

function CompanyModalContents({
  companyInsightData,
  isLoading,
} : ModalContentsProps): JSX.Element {
  const {
    companyName,
    companyLogo,
    industries,
    companyEnrichedData,
  } = companyInsightData;

  const tags = useMemo<ExperienceTag[] | undefined>(() => {
    return industries?.map((industry) => ({
      text: industry.value,
      type: ExperienceTagType.Industry,
      askedByUser: industry.askedByUser,
    }));
  }, [industries]);

  if (isLoading) {
    return <CompanyModalSkeleton />;
  }

  return (
    <>
      <ModalHeader >
        <CompanyLogoImage src={ companyLogo }>
          <LogoFallback />
        </CompanyLogoImage>
        <CompanyBaseDetailsWrapper >
          <CompanyNameAndLocationWrapper>

            {companyName && (
              <CompanyNameLabel>
                {companyName}
              </CompanyNameLabel>
            )}

            {companyEnrichedData.companyLocation && (
              <CompanyLocationLabel>
                {formatExactLocation(companyEnrichedData.companyLocation)}
              </CompanyLocationLabel>
            )}

          </CompanyNameAndLocationWrapper>

          {tags && (
            <ExperienceTags
              tags={ tags }
            />
          )}
        </CompanyBaseDetailsWrapper>

      </ModalHeader>

      <Divider />

      <CompanyOtherDetailsWrapper>

        <CompanyProperties
          name={ companyName }
          size={ companyEnrichedData.companySize }
          foundedAt={ companyEnrichedData.companyFoundedAt }
          website={ companyEnrichedData.companyWebsite }
          linkedinUrl={ companyEnrichedData.companyLinkedinUrl }
          ipoStatus={ companyEnrichedData.companyIpoStatus }
          lastFundingType={ companyEnrichedData.companyLastFundingType }
        />

        <CompanyDescription>
          {companyEnrichedData.companyFullDescription}
        </CompanyDescription>

      </CompanyOtherDetailsWrapper>
    </>
  );
}

export default CompanyModalContents;
